module.exports = __webpack_public_path__ + "img/neteller.63d2e81c.svg";